// extracted by mini-css-extract-plugin
export default {"products":"Products_products__-41Gc","sectionTitle":"Products_sectionTitle__1t3j-","list":"Products_list__R4CCJ"};